






























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { CenterSetting } from '@core/interfaces/center-setting';
import store from '@app/store';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import StripeConnectLink from '@shared/components/forms/inputs/stripe-connect/stripe-connect-link.vue';
import CustomContactFieldsHelper from './helpers/custom-contact-fields-helper';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import ModulesHelper from '@core/services/modules.helper';
import AccessControlConfigForm from '@shared/components/forms/inputs/access-control-config-form/access-control-config-form.vue';
import { setProp } from '@shared/helpers/operators';

library.add(faPlus);

@Component({
  name: 'bpc-center-settings-v2',
  components: {
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-std-form': StdForm,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-stripe-connect-link': StripeConnectLink,
    'bpc-access-control-config-form': AccessControlConfigForm,
  },
})
export default class CenterSettingsV2 extends Vue {
  $refs!: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & { saveEntity(): void; formModel: any };
    deleteMediaFileConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    accessControlConfigForm: InstanceType<typeof AccessControlConfigForm> & {
      saveEntity(): void;
      onEntitySaved(e): void;
      formModel: any;
    };
  };

  @Prop({ type: String, default: 'global' }) readonly tabName: string;

  public showEditForm: boolean = false;

  /**
   * Form
   */
  model = null;
  modules = [
    'global',
    'users',
    'contacts',
    'subscriptions',
    'bookings',
    'activities',
    'accounting',
    'contracts',
    'point_of_sales',
    'online_shop',
    'website',
    'access_control',
  ];
  saving = false;
  centerSetting: CenterSetting = new CenterSetting();
  originalAccessControlConfig: string = null;
  accessControlConfigFormModel: AccessControlConfigInterface = {
    id: null,
    access_control_service: null,
    access_control_key: null,
    access_control_url: null,
    early_access_delay: null,
  };
  modelLoadedValue: boolean = false;
  modelLoadedSinceTimestamp: number = null;
  firstLoadTimestamp: number = null;
  modelHasChanged: boolean = false;
  showModelHasChangeConfirmationModal: boolean = false;
  futureTabName: string = null;

  // COMPUTED

  // Access Control Module
  get hasAccessControlModuleActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCESS_CONTROL_MODULE_NAME);
  }

  get formSavePath() {
    const tabKebabName = this.tabName.replace('_', '-');
    return this.$bpcApiRouteHelper.getApiPath(`center-settings/${tabKebabName}-setting`);
  }

  /* Lifecycle hooks */

  get modelLoaded() {
    return this.modelLoadedValue;
  }

  set modelLoaded(value) {
    this.modelLoadedValue = value;
    if (value) {
      this.modelLoadedSinceTimestamp = Date.now();
      if (!this.firstLoadTimestamp) {
        this.firstLoadTimestamp = Date.now();
      }
    }
  }

  created() {
    this.onEdit();
  }

  onSavingEntity(value) {
    this.saving = value;
  }

  onTabChange(tabName: string) {
    this.futureTabName = tabName;
    if (
      this.tabName === 'access_control' &&
      this.accessControlConfigHasChanged(this.$refs.accessControlConfigForm.formModel)
    ) {
      this.showModelHasChangeConfirmationModal = true;
      return;
    }
    if (this.modelLoaded && this.modelHasChanged) {
      this.showModelHasChangeConfirmationModal = true;
      return;
    }
    this.onConfirmTabChange();
  }

  onConfirmTabChange() {
    this.$router.push({
      name: 'admin-center-settings-v2',
      params: {
        tabName: this.futureTabName,
      },
    });
    this.modelLoaded = false;
    this.modelHasChanged = false;
    this.futureTabName = null;
  }

  onCancelTabChange() {
    this.futureTabName = null;
  }

  onModelLoaded($event) {
    this.modelLoaded = true;
    this.modelHasChanged = false;
  }

  onModelChange($event) {
    // The model is loaded and it has changed after 500ms
    if (!this.modelLoaded || !this.modelLoadedSinceTimestamp) {
      this.modelHasChanged = false;
    } else if (this.modelLoaded) {
      // The model is loaded we check if it has changed
      // we wait 1500ms for the first load to mark the model as changed
      // after the first load we wait 500ms to mark the model as changed
      const diff = Date.now() - this.modelLoadedSinceTimestamp;
      const firstLoadDiff = Date.now() - this.firstLoadTimestamp;
      if (firstLoadDiff > 1500 && diff > 500) {
        this.modelHasChanged = true;
      } else {
        this.modelHasChanged = false;
      }
    }
  }

  onInputCustomEvent(event) {
    const eventName = event.eventName;
    switch (eventName) {
      case 'selectedCityFromPostalCode':
        // When updating the zip code field, update the city field
        setProp(this.$refs.stdForm?.formModel, 'city', event.value);
        break;
      case 'selectedCountryFromPostalCode':
        // When updating the zip code field, update the country field
        setProp(this.$refs.stdForm?.formModel, 'country', event.value.toLowerCase());
        break;
      default:
        break;
    }
  }

  mounted() {
    this.modelLoaded = false;
    this.modelHasChanged = false;
    this.$root.$on('updateDefaultPriceCategoryForPostalCodes', event => {
      setProp(
        this.$refs.stdForm?.formModel,
        'default_price_category_id_for_postal_codes',
        event?.id ?? null,
      );
    });
    const url = `6/config/center_setting`;
    this.$bpcApi
      .get(url)
      .toPromise()
      .then(response => {
        console.log('response CONFIGV2', response);
      });
  }
  destroyed() {
    this.$root.$off('updateDefaultPriceCategoryForPostalCodes');
  }

  // updated () { }
  // destroyed () { }

  onEdit() {
    this.centerSetting = new CenterSetting();
    this.centerSetting.id = store.getters['centerSettings/centerSettings'].id; // We have to determine the option id of the current center
    this.showEditForm = true;
  }

  async onEditFormSave() {
    // Prepare custom contact fields using a helper function
    const customContactFields = CustomContactFieldsHelper.prepareCustomContactFields(
      this.$refs.stdForm.formModel,
    );
    this.$refs.stdForm.formModel.custom_contact_fields = customContactFields;
    // Check if the access control module is activated
    if (this.tabName === 'access_control' && this.hasAccessControlModuleActivated) {
      this.$refs.accessControlConfigForm.saveEntity();
    } else {
      // Save the center settings as normal
      this.$refs.stdForm.saveEntity();
    }
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.$router.go(null);
  }

  getModalTitle() {
    return 'Edit Center Settings';
  }

  getDeleteMediaFileConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'media-file-delete-modal',
      title: this.$t('global.modals.media-delete.title') as string,
      body: this.$t('global.modals.media-delete.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.permanent_delete') as string,
      acceptButtonVariant: 'danger',
    };
  }

  onSuccessMediaFileDelete() {
    this.$refs.deleteMediaFileConfirmationModal.onCloseModal();
  }

  showDeleteMediaFileModal(mediaId: string) {
    this.$refs.deleteMediaFileConfirmationModal.onOpenModal(mediaId);
  }

  onAccessControlConfigLoaded(formModel: AccessControlConfigInterface) {
    this.originalAccessControlConfig = [
      formModel.access_control_service,
      formModel.access_control_key,
      formModel.access_control_url,
      formModel.early_access_delay,
    ].join('--');
  }

  accessControlConfigHasChanged(formModel: AccessControlConfigInterface) {
    const parsed: string = [
      formModel.access_control_service,
      formModel.access_control_key,
      formModel.access_control_url,
      formModel.early_access_delay,
    ].join('--');
    return this.originalAccessControlConfig !== parsed;
  }

  onFormChanged(formModel) {
    this.model = formModel;
  }
}
